<template>
    <span
        class="search-button"
        :class="{ active: isOpened }"
        @click="toggle"
    >
        <i class="fas fa-search"></i>
        <portal to="header" v-if="isOpened">
            <instant-search
                :hits-per-page="hitsPerPage"
                :placeholder="placeholder"
                :show-close="true"
                @close="dismiss"
            ></instant-search>
        </portal>
    </span>
</template>
<script>
    import InstantSearch from './AlgoliaSearch';
    export default {
        components: { InstantSearch },
        props: {
            hitsPerPage: {
                type: Number,
                default: 5
            },
            placeholder: {
                type: String,
                default: 'SEARCH'
            }
        },
        data() {
            return {
                isOpened: false
            }
        },
        created() {
            const escapeHandler = event => {
                if (event.key === 'Escape' && this.isOpened) {
                    this.dismiss();
                }
            };

            document.addEventListener('keydown', escapeHandler);

            this.$once('hook:destroyed', () => {
                document.removeEventListener('keydown', escapeHandler);
            });
        },
        methods: {
            toggle() {
                if (this.isOpened = !this.isOpened) {
                    this.addClass();
                } else {
                    this.removeClass();
                }
            },
            dismiss() {
                this.isOpened = false;
                this.removeClass();
            },
            addClass() {
                document.getElementById('header').classList.add('search-visible');
            },
            removeClass() {
                document.getElementById('header').classList.remove('search-visible');
            }
        }
    }
</script>